export default "__VITE_ASSET__DJDJQYLI__"